/**
 * Campaign-level rollup pill — one of unlinked / partial / linked.
 *
 * Sits next to the campaign status pill in the header so the team can see
 * at a glance whether platform IDs are wired up. The per-platform detail
 * lives in PlatformHealthBadge — this pill is the summary.
 */

import React from 'react';
import type { CgBoostLinkStatus } from '../../types/cgBoost';
import { Pill } from '../ui';

type Tone = React.ComponentProps<typeof Pill>['tone'];

const TONE: Record<CgBoostLinkStatus, Tone> = {
  unlinked: 'warning',
  partial: 'info',
  linked: 'success',
};

const LABEL: Record<CgBoostLinkStatus, string> = {
  unlinked: 'No platforms linked',
  partial: 'Partially linked',
  linked: 'All planned platforms linked',
};

const SHORT_LABEL: Record<CgBoostLinkStatus, string> = {
  unlinked: 'Unlinked',
  partial: 'Partial',
  linked: 'Linked',
};

interface Props {
  status: CgBoostLinkStatus;
  /** Short = just the state name. Default = full sentence. */
  short?: boolean;
}

const LinkStatusPill: React.FC<Props> = ({ status, short }) => (
  <Pill tone={TONE[status]} size="sm" title={LABEL[status]}>
    {short ? SHORT_LABEL[status] : LABEL[status]}
  </Pill>
);

export default LinkStatusPill;
